module.exports = __webpack_public_path__ + "media/app/assets/images/arsenal-thumb-c21a08a49616af7e41acfade21baccab.jpg";